import { formatDateISO, startOfWeek, today } from '@/app/shared/utils/date.utils';
import {
  PAYMENT_STATUS_PRESENTATION,
  PaymentOrderFilters,
  PaymentStatus,
  PaymentStatusPresentation,
} from '../models/payment-order.model';
import { EMPTY_VALUE } from './hospital-account-display.util';

const UNKNOWN_STATUS: PaymentStatusPresentation = {
  label: EMPTY_VALUE,
  variant: 'neutral',
  className: '',
};

export const paymentStatusPresentation = (
  status: PaymentStatus | null,
): PaymentStatusPresentation => (status && PAYMENT_STATUS_PRESENTATION[status]) || UNKNOWN_STATUS;

export const orEmpty = (value: string | null): string => value?.trim() || EMPTY_VALUE;

export const defaultPaymentOrderFilters = (): Required<PaymentOrderFilters> => ({
  startDate: formatDateISO(startOfWeek(today())),
  endDate: formatDateISO(today()),
});
